import { render, staticRenderFns } from "./ResetExpired.vue?vue&type=template&id=29ab8efc&scoped=true"
import script from "./ResetExpired.vue?vue&type=script&lang=js"
export * from "./ResetExpired.vue?vue&type=script&lang=js"
import style0 from "./ResetExpired.vue?vue&type=style&index=0&id=29ab8efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab8efc",
  null
  
)

export default component.exports